var layout_default = {
  "layoutWrapper": "CoU6I",
  "layout": "i6cRL",
  "designOnLayout": "_2KIkV",
  "designOnCell": "bYJuG",
  "cell": "oT0Rl",
  "mobile": "vfCi9"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
